import React from 'react'
import PlanProgress from '../atoms/PlanProgress/PlanProgress'

function PlanProgressContainer(props) {
    const { data } = props
    return <PlanProgress plan={data.plans.data} />
}

export default PlanProgressContainer
